import { useCallback, useContext } from 'react';
import {
  saveResponse,
  initializeResponse as initializeResponseAction,
  submitResponse as submitResponseAction,
} from '../actions/response';
import {
  feedbackResponse,
  updateResponse,
} from '../store/FeedbackResponseState';
import UIContext from '../store/UIState';

function useResponse() {
  const response = useContext(feedbackResponse);
  const responseDispatch = useContext(updateResponse);
  const { dispatch: uiDispatch } = useContext(UIContext);

  const saveFeedbackResponse = useCallback(
    (id, answer) => {
      const action = saveResponse(id, answer);
      responseDispatch(action);
    },
    [responseDispatch, response]
  );

  const initializeResponse = useCallback(
    (questions) => {
      const action = initializeResponseAction(questions);
      responseDispatch(action);
    },
    [initializeResponseAction, responseDispatch]
  );

  const submitResponse = useCallback(
    (applicationId, feedbackIntent, userFeedback, sifProfileId) => {
      submitResponseAction(
        applicationId,
        feedbackIntent,
        userFeedback,
        sifProfileId
      )(uiDispatch);
    }
  );

  return {
    response,
    saveFeedbackResponse,
    submitResponse,
    initializeResponse,
  };
}

export default useResponse;
